import { Link } from "react-router-dom";
import { Logo } from "@/components/app/Sidebar";
import { PageTour } from "@/components/app/PageTour";

export const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="flex min-h-screen flex-col bg-canvas">
    <header className="mx-auto flex w-full max-w-[960px] items-center px-6 py-5 max-sm:px-4">
      <Link to="/" data-testid="auth-logo-link"><Logo /></Link><PageTour className="ml-auto" />
    </header>
    <main className="flex flex-1 items-start justify-center px-6 pt-12 tl-page max-sm:px-4 max-sm:pt-6">
      <div className="w-full max-w-[400px] space-y-6">
        <div className="space-y-1">
          <h1 className="text-3xl font-semibold tracking-tight text-ink">{title}</h1>
          {subtitle && <p className="text-sm text-ink-secondary">{subtitle}</p>}
        </div>
        <div className="panel p-6 max-sm:p-5">{children}</div>
        {footer && <div className="text-sm text-ink-secondary">{footer}</div>}
      </div>
    </main>
  </div>
);
